
import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';


export type requestDTOUploadImage = {
    file: FormData;
  };
  
  export type UploadImageResponse = {
    audioUrl: string;
  };
  
  export const addInstitutePicture = ({
    file,
  }: requestDTOUploadImage): Promise<UploadImageResponse> => {
    return axios.post('/superAdmin/upload/audio-file', file);
  };
  
  type UseUpdateInstituteOptions1 = {
    config?: MutationConfig<typeof addInstitutePicture>;
  };
  
  export const useUploadAudio = ({ config }: UseUpdateInstituteOptions1 = {}) => {
    return useMutation({
      onSuccess: () => {},
      ...config,
      mutationFn: addInstitutePicture,
    });
  };
  